import {InjectionToken} from "@angular/core";

export class FUIConfig {
    /**
     * Navigation path key - identifies the location of the navigation model data in the application.
     * @type {InjectionToken<string>}
     */
    public static readonly NAVIGATION_PATH_KEY: InjectionToken<string> = new InjectionToken("navigationPath");

    public providedLoader: any = {};
    public navigationPath?: string;
}
